import { Components, radioClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiRadioGroup to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/radio-group/#css
 */
export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: theme.spacing(0, 0.5),
      height: '32px',
      width: '32px',
      ['& svg']: {
        height: '20px',
        width: '20px',
      },
      [`&.${radioClasses.checked}`]: {
        [` svg[data-testid="RadioButtonUncheckedIcon"]`]: {
          color: theme.palette.text.secondary,
        },
      },
      ['&:hover']: {
        backgroundColor:
          theme.palette.mode === 'light' ? theme.palette.designSystem.grey[50] : theme.palette.designSystem.grey[700],
        borderRadius: '4px',
      },
    }),
  },
};
